import { ActionTypes } from '../constants/index';

export const getSubscriptionDetail = (payload: any) => ({
  type: ActionTypes.SUBSCRIPTION_DETAILS_REQUEST,
  payload,
});